import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PartnerApiService } from '@vendasta/marketplace-apps';
import { catchError, combineLatest, map, of, shareReplay, switchMap } from 'rxjs';
import { MARKETPLACE_APP_ID_TOKEN, MARKET_ID_TOKEN, PARTNER_ID_TOKEN } from './tokens';

const DEFAULT_PRODUCT_NAME = 'Conversations AI';

@Injectable({
  providedIn: 'root',
})
export class ConversationProductNameService {
  private readonly partnerId$ = inject(PARTNER_ID_TOKEN);
  private readonly marketId$ = inject(MARKET_ID_TOKEN);
  private readonly marketplaceAppId = inject(MARKETPLACE_APP_ID_TOKEN);
  private readonly marketplaceService = inject(PartnerApiService);

  readonly productName: Signal<string> = toSignal(
    combineLatest([this.partnerId$, this.marketId$]).pipe(
      switchMap(([partnerId, marketId]) =>
        this.marketplaceService.getMultiApp({
          appKeys: [{ appId: this.marketplaceAppId }],
          partnerId,
          marketId,
        }),
      ),
      map((resp) => resp.apps[0]?.sharedMarketingInformation?.name ?? DEFAULT_PRODUCT_NAME),
      catchError(() => of(DEFAULT_PRODUCT_NAME)),
      shareReplay({ refCount: true, bufferSize: 1 }),
    ),
    { initialValue: DEFAULT_PRODUCT_NAME },
  );
}
